// Third Party Imports
import React from 'react';
import {FormInput} from '@homeaway/react-form-components';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import InputTel from '@homeaway/react-input-tel';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import ReCAPTCHA from 'react-google-recaptcha';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__12 as close} from '@homeaway/svg-defs/lib/defs/CLOSE__12';
import {CHECK__12 as check} from '@homeaway/svg-defs/lib/defs/CHECK__12';

// Relative Imports
import './CreateAccount.less';
import ErrorAlert from './ErrorAlert';
import {getKey} from '../utils/commonUtil';

class CreateAccount extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getPasswordStyle(passwordNotify) {
        const passwordStyle = {};
        if (passwordNotify.hasNumber) {
            passwordStyle.passwordNumberIcon = check;
            passwordStyle.passwordNumberIconVariant = 'icon-success';
        } else {
            passwordStyle.passwordNumberIcon = close;
            passwordStyle.passwordNumberIconVariant = 'icon-muted';
        }

        if (passwordNotify.hasLetter) {
            passwordStyle.passwordLetterIcon = check;
            passwordStyle.passwordLetterIconVariant = 'icon-success';
        } else {
            passwordStyle.passwordLetterIcon = close;
            passwordStyle.passwordLetterIconVariant = 'icon-muted';
        }

        if (passwordNotify.isStrong) {
            passwordStyle.passwordStrongIcon = check;
            passwordStyle.passwordStrongIconVariant = 'icon-success';
        } else {
            passwordStyle.passwordStrongIcon = close;
            passwordStyle.passwordStrongIconVariant = 'icon-muted';
        }

        return passwordStyle;
    }

    helpModalLink = () => {
        const {translations, onHelpClick} = this.props;

        return (
            <span className="help-link-wrapper">
                <ButtonLink
                    type="button"
                    id={'helpLink'}
                    className="help_link"
                    label={translations['ipmob.help.modal.link']}
                    onClick={onHelpClick}
                    href="#"
                />
            </span>
        );
    };

    render() {
        let {
            translations,
            firstNameVal,
            firstNameError,
            handleFirstNameChange,
            handleFirstNameBlur,
            lastNameVal,
            lastNameError,
            handleLastNameChange,
            handleLastNameBlur,
            countryCodeVal,
            phoneNumberVal,
            phoneNumberError,
            handlePhoneNumberChange,
            handleCountryCodeChange,
            companyNameVal,
            companyNameError,
            handleCompanyNameChange,
            handleCompanyNameBlur,
            emailVal,
            emailError,
            handleEmailChange,
            handleEmailBlur,
            handlePhoneBlur,
            passwordVal,
            passwordError,
            handlePasswordChange,
            handlePasswordBlur,
            passwordFieldType,
            handleFormSubmit,
            enableButton,
            togglePasswordType,
            onPasswordKeyUp,
            passwordNotify,
            triggerEdapEventOnFocus,
            triggerEdapEventOnPhoneFocus,
            accountExistsError,
            handleFormAlertDismiss,
            onCaptchaChange,
            getInputTel,
            setRecaptchaRef,
            environment
        } = this.props;

        const passwordStyle = (passwordNotify.display) ? this.getPasswordStyle(passwordNotify) : null;
        return (
            <div id="createAccount" className="create-account-pg">
                <img className="create-account-bg-img" src= {backgroundImage()}/>
                <div className="panel-head">
                    <h1 className="head">{translations['ipmob.create_account.heading_3']}</h1>
                    <span className="sub-head">{translations['ipmob.create_account.subheading_1']}</span>
                </div>
                {
                    (accountExistsError)
                        ? <ErrorAlert
                                message={translations[accountExistsError]}
                                dismissFormAlert={handleFormAlertDismiss}
                                innerComponent={(accountExistsError === 'ipmob.create_account.error.account.exists') ? this.helpModalLink() : null}
                          />
                        : null
                }
                <form role="form" onSubmit={handleFormSubmit}>
                    <div className="input-container" aria-label="Big form">
                        <div className="wrapper">
                            <div className="content-col-left">
                                <FormInput
                                    id="firstName"
                                    type="text"
                                    name="First Name"
                                    label={translations['ipmob.create_account.label_3']}
                                    value={firstNameVal}
                                    errorMsg={translations[firstNameError]}
                                    onChange={handleFirstNameChange}
                                    maxLength="64"
                                    onFocus={triggerEdapEventOnFocus}
                                    onBlur={handleFirstNameBlur}
                                />
                            </div>
                            <div className="content-col-right">
                                <FormInput
                                    id="lastName"
                                    type="text"
                                    name="Last Name"
                                    label={translations['ipmob.create_account.label_4']}
                                    value={lastNameVal}
                                    errorMsg={translations[lastNameError]}
                                    onChange={handleLastNameChange}
                                    maxLength="64"
                                    onFocus={triggerEdapEventOnFocus}
                                    onBlur={handleLastNameBlur}
                                />
                            </div>
                        </div>
                        <div className="clearfix"/>
                        <div className="wrapper">
                            <div className="content-col-left phone-number">
                                <InputTel
                                    ref= {getInputTel}
                                    id="phoneNumber"
                                    name="Phone"
                                    className="phone-number"
                                    labels={{phoneNumber: translations['ipmob.create_account.label_8']}}
                                    phoneNumber={phoneNumberVal}
                                    countryCode={countryCodeVal}
                                    errorMsg={translations[phoneNumberError]}
                                    onPhoneChange={handlePhoneNumberChange}
                                    onCountryCodeChange={handleCountryCodeChange}
                                    onPhoneBlur={handlePhoneBlur}
                                    onPhoneFocus={triggerEdapEventOnPhoneFocus}
                                />
                            </div>
                            <div className="content-col-right">
                                <FormInput
                                    id="companyName"
                                    type="text"
                                    name="Company Name"
                                    label={translations['ipmob.create_account.label_2']}
                                    value={companyNameVal}
                                    errorMsg={translations[companyNameError]}
                                    onChange={handleCompanyNameChange}
                                    maxLength="64"
                                    onFocus={triggerEdapEventOnFocus}
                                    onBlur={handleCompanyNameBlur}
                                />
                            </div>
                        </div>
                        <div className="clearfix"/>
                        <div className="wrapper">
                            <div className="content-col-left">
                                <FormInput
                                    id="email"
                                    className="email"
                                    type="email"
                                    name="Email Address"
                                    label={translations['ipmob.create_account.label_5']}
                                    value={emailVal}
                                    errorMsg={translations[emailError]}
                                    onChange={handleEmailChange}
                                    onBlur={handleEmailBlur}
                                    onFocus={triggerEdapEventOnFocus}
                                    maxLength="64"
                                />
                            </div>
                            <div className="content-col-right">
                                <FormInput
                                    id="password"
                                    type={passwordFieldType}
                                    name="Password"
                                    label={translations['ipmob.create_account.label_6']}
                                    value={passwordVal}
                                    errorMsg={translations[passwordError]}
                                    onChange={handlePasswordChange}
                                    onBlur={handlePasswordBlur}
                                    onKeyUp={onPasswordKeyUp}
                                    maxLength="32"
                                    rightContent={
                                        (passwordVal)
                                            ? <span className="toggle-pwd" onClick={togglePasswordType}>
                                                {(passwordFieldType === 'password') ? translations['ipmob.create_account.show'] : translations['ipmob.create_account.label_7']}
                                            </span>
                                            : null
                                    }
                                    contentClickable
                                    onFocus={triggerEdapEventOnFocus}
                                />
                                {
                                    (passwordNotify.display)
                                        ? (<div className="wrapper">
                                            {
                                                (passwordNotify.hasNumber && passwordNotify.hasLetter && passwordNotify.isStrong)
                                                    ? (<div className="content-col password-notify">
                                                        {
                                                            // eslint-disable-next-line react/no-danger
                                                            <div dangerouslySetInnerHTML={{__html: translations['ipmob.password.notification']}}/>
                                                        }
                                                    </div>)
                                                    : (<div className="content-col password-notify">
                                                        <div>
                                                            <span title={passwordStyle.passwordStrongIcon} className="pwd-icon-holder">
                                                                <SVGIcon markup={passwordStyle.passwordStrongIcon} className={passwordStyle.passwordStrongIconVariant}/>
                                                            </span>
                                                            {translations['ipmob.password.error_text1']}
                                                        </div>
                                                        <div>
                                                            <span title={passwordStyle.passwordLetterIcon} className="pwd-icon-holder">
                                                                <SVGIcon markup={passwordStyle.passwordLetterIcon} className={passwordStyle.passwordLetterIconVariant}/>
                                                            </span>
                                                            {translations['ipmob.password.error_text2']}
                                                        </div>
                                                        <div>
                                                            <span title={passwordStyle.passwordNumberIcon} className="pwd-icon-holder">
                                                                <SVGIcon markup={passwordStyle.passwordNumberIcon} className={passwordStyle.passwordNumberIconVariant}/>
                                                            </span>
                                                            {translations['ipmob.password.error_text3']}
                                                        </div>
                                                    </div>)
                                            }
                                        </div>)
                                        : null
                                }
                            </div>
                        </div>
                        <div className="clearfix"/>
                        <div className="wrapper">
                            <div className="content-col-left"/>
                            <div id="captcha-holder" className="content-col-right">
                                <ReCAPTCHA
                                    ref={setRecaptchaRef}
                                    sitekey={getKey(environment)}
                                    size="invisible"
                                    onChange={onCaptchaChange}
                                />
                            </div>
                        </div>
                        <div className="wrapper">
                            {
                                (enableButton)
                                    ? (<div className="content-col">
                                        <h3 className="success-msg1">{`${translations['ipmob.create_account.subheading_3']}, ${firstNameVal}!`}</h3>
                                        <h4 className="success-msg2">{translations['ipmob.create_account.subheading_2']}</h4>
                                    </div>)
                                    : null
                            }
                            {
                                // eslint-disable-next-line react/no-danger
                                <div className="info-msg" dangerouslySetInnerHTML={{__html: translations['ipmob.create_account.info_msg']}}/>
                            }
                        </div>
                        <div className="wrapper">
                            <div className="content-col create-account-button">
                                <ButtonPrimary
                                    label={translations['ipmob.create_account.button.text_1']}
                                    type="submit"
                                    value="Submit"
                                    disabled = {!enableButton}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default CreateAccount;
